"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var react_prop_types_1 = require("../react-prop-types");
var fade_1 = require("../fade");
var classnames_1 = require("../util/classnames");
var _1 = require("../util/_");
var react_overlays_1 = require("../react-overlays");
var Overlay = /** @class */ (function (_super) {
    __extends(Overlay, _super);
    function Overlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Overlay.prototype.render = function () {
        var transition = this.props.animation;
        var child = this.props.children;
        var customProps = _1.omit(this.props, ['children', 'animation']);
        if (transition === true) {
            transition = fade_1.Fade;
        }
        if (transition === false) {
            transition = null;
        }
        if (!transition) {
            child = React.cloneElement(child, {
                className: classnames_1.classNames('in', child.props.className)
            });
        }
        return (React.createElement(react_overlays_1.BaseOverlay, __assign({}, customProps, { transition: transition }), child));
    };
    Overlay.propTypes = Object.assign({}, react_overlays_1.BaseOverlay.propTypes, {
        /**
         * Set the visibility of the Overlay
         */
        show: PropTypes.bool,
        /**
         * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
         */
        rootClose: PropTypes.bool,
        /**
         * A callback invoked by the overlay when it wishes to be hidden. Required if
         * `rootClose` is specified.
         */
        onHide: PropTypes.func,
        /**
         * Use animation
         */
        animation: PropTypes.oneOfType([
            PropTypes.bool,
            react_prop_types_1.elementType
        ]),
        /**
         * Callback fired before the Overlay transitions in
         */
        onEnter: PropTypes.func,
        /**
         * Callback fired as the Overlay begins to transition in
         */
        onEntering: PropTypes.func,
        /**
         * Callback fired after the Overlay finishes transitioning in
         */
        onEntered: PropTypes.func,
        /**
         * Callback fired right before the Overlay transitions out
         */
        onExit: PropTypes.func,
        /**
         * Callback fired as the Overlay begins to transition out
         */
        onExiting: PropTypes.func,
        /**
         * Callback fired after the Overlay finishes transitioning out
         */
        onExited: PropTypes.func
    });
    Overlay.defaultProps = {
        animation: fade_1.Fade,
        rootClose: true,
        show: false,
        shouldUpdatePosition: true
    };
    return Overlay;
}(React.Component));
exports.Overlay = Overlay;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/overlay/overlay.js
// module id = 197
// module chunks = 0 1 2 3 4 5 6